import { styled, keyframes } from '@mui/material/styles';

const movingBgImage = keyframes`
  0% {  
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const Wrapper = styled('section')`
  background-color: blue;
  background-image: url('/static/images/animated-bg.jpg');
  animation: ${movingBgImage} 25s ease-in-out infinite;
  padding: 4rem 0;
  color: #fff;

  h1 {
    font-family: 'Inter', sans-serif;
    font-size: ${props => props.theme.customTheme.sizes.xxBig};
    margin: 0;
    font-weight: 700;
  }

  @media (max-width: 767.98px) {
    padding: 3rem 0;
    h1 {
      font-size: ${props => props.theme.customTheme.sizes.xLarge};
    }
  }
`;

export { Wrapper };
